<!-- TEMPLATE CONTRACT: Ui Card Component owns the visible Angular template structure for src/app/shared/ui/ui-card/ui-card.component.html. -->
<p-card [styleClass]="'ui-card'">
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (title()) {
    <ng-template pTemplate="title">
      <span class="ui-card__title">{{ title() | uiLabelTranslate }}</span>
    </ng-template>
  }
  <ng-template pTemplate="content">
    <ng-content />
  </ng-template>
</p-card>
